module.exports = __webpack_public_path__ + "hungary.svg?844eeb9e8fa1b27feb2dba2dbc2e2394";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/hungary.svg
// module id = 188
// module chunks = 10